module.exports = "/_next/static/images/button_bg-f7ab0fd96d2a589a12e24ba7b20cdbbf.png";